module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Resistor_16"],"polygon":[{"$":{"points":"3 9 0 9 0 7 4 7 4.91 8.66 7.23 3.33 9.55 8.66 11.88 3.33 13.5 7 16 7 16 9 12.6 9 11.88 7.33 9.55 12.67 7.23 7.34 4.91 12.67 3 9","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Resistor_16.svg
// module id = 60eF
// module chunks = 1